export class ServiceDashboardModel {

}
